import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { TranslateModule } from '@ngx-translate/core';

import { MgFormFieldModule } from '@app/src/app/form-field';

import { RoleSelectComponent } from './RoleSelect.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgFormFieldModule,

    // External dependencies
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    CommonModule,
    TranslateModule,
  ],
  declarations: [RoleSelectComponent],
  exports: [RoleSelectComponent],
})
export class RoleSelectModule {}
